import React from "react";
import { FaEye, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { deleteExam } from "../../../redux/slice/examsSlice";
import DeleteButton from "../common/DeleteButton";
import moment from "moment";

const ExamItem = ({ data, index }) => {
  const navigate = useNavigate();

  const handleView = () => {
    navigate(`/admin/view-exam/${data._id}`);
  };

  const currentDate = new Date();

  const fromDate = new Date(data.fromDate);
  const toDate = new Date(data.toDate);

  const from = moment(fromDate).format("MMM DD YY, h:mm a");
  const to = moment(toDate).format("MMM DD YY, h:mm a");

  return (
    <tr className="border-b">
      <td className="px-2 py-4 overflow-clip">
        <span>{index + 1}</span>
      </td>
      <td className="px-2 py-4 overflow-clip">
        <span>{data.topicName}</span>
      </td>
      <td className="px-2 py-4 overflow-clip">
        <span>{from}</span>
      </td>
      <td className="px-2 py-4 overflow-clip">
        <span>{to}</span>
      </td>
      <td className="px-2 py-4 overflow-clip flex flex-row gap-4 justify-center items-center">
        <button onClick={handleView} className="text-blue-700">
          <FaEye className="text-[18px]" />
        </button>
        {currentDate < fromDate ? (
          <DeleteButton data={data._id} toDispatch={deleteExam} type="Exam" />
        ) : (
          <FaTrash title="Not allowed" className="text-gray-500" />
        )}
      </td>
    </tr>
  );
};

export default ExamItem;
